import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

//* Method to fill param request from table 'Cupones'
export const configTableCupones = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    {
      key: 'codigo', sortable: true, stickyColumn: true, label: 'Código',
    },
    { key: 'capacidad', sortable: true },
    { key: 'descuento', sortable: true },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsParams: { action: 1, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wscupones', //* WebService name
    filterGetter: 'servicioEscolar/filterCupones', //* Getter function to filter data
  })
  return {
    tableColumns,
    configRequest,
  }
}
//* Make http request to get info by asignature's id
export const cuponInfo = idCupon => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 2,
    id: idCupon,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wscupones')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
